import { defineMessages } from 'react-intl'

export default defineMessages({
  cardTitle: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.Title',
    defaultMessage: 'SAML Identity Provider'
  },
  edit: {
    id: 'Edit',
    defaultMessage: 'Edit'
  },
  emailAttribute: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.EmailAttribute',
    defaultMessage: 'Email Attribute'
  },
  familyNameAttribute: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.FamilyNameAttribute',
    defaultMessage: 'Family Name Attribute'
  },
  identityProvider: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.IdentityProvider',
    defaultMessage: 'Identity Provider'
  },
  identityProviderAzureActiveDirectory: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.IdentityProviderAzureActiveDirectory',
    defaultMessage: 'Azure Active Directory'
  },
  identityProviderOkta: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.IdentityProviderOkta',
    defaultMessage: 'Okta'
  },
  identityProviderOther: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.IdentityProviderOther',
    defaultMessage: 'Other'
  },
  metadata: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.SamlMetadata',
    defaultMessage: 'SAML Metadata'
  },
  usernameAttribute: {
    id: 'OrganizationSecurityPage.SamlIdentityProviders.UsernameAttribute',
    defaultMessage: 'Name Attribute'
  }
})
